import { Input, MenuItem, Select } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SelectionEnum } from "@ryde/shared";

import { Noop } from "../noop";
import { SelectOptionsCheck } from "./select-options.check";
import {
  SelectOptionItemStyled,
  SelectOptionsWrapperStyled,
} from "./select-options.styled";

interface ISelectOptionsDropdown {
  checked: SelectionEnum;
  setChecked: (val: SelectionEnum) => void;
}

export const SelectOptionsDropdown: FC<ISelectOptionsDropdown> = ({
  checked,
  setChecked,
}) => {
  const { t } = useTranslation();
  return (
    <SelectOptionsWrapperStyled>
      <SelectOptionsCheck checked={checked} setChecked={setChecked} />
      <Select
        value={checked}
        data-e2e-checked={checked ? "checked" : "unchecked"}
        onChange={({ target: { value } }) => {
          setChecked(value as SelectionEnum);
        }}
        input={<Input />}
        renderValue={Noop}
        disableUnderline
      >
        {[SelectionEnum.All, SelectionEnum.Some, SelectionEnum.None].map(
          statusLabel => (
            <MenuItem
              style={{
                display: statusLabel === SelectionEnum.Some ? "none" : "block",
              }}
              key={statusLabel}
              data-e2e="select-options-dropdown-wrapper"
              value={statusLabel}
            >
              <SelectOptionItemStyled>
                {t(`selectListLabel.${statusLabel}`)}
              </SelectOptionItemStyled>
            </MenuItem>
          ),
        )}
      </Select>
    </SelectOptionsWrapperStyled>
  );
};
